var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"height":"100%"}},[_c('a-row',{staticStyle:{"margin-top":"20px"}},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title[_vm.$i18n.locale]))])]),_c('imageStore')],1)}
var staticRenderFns = []

export { render, staticRenderFns }